module.exports = __webpack_public_path__ + "static/media/logo.64519a2a.svg";